import { FC, ReactNode } from 'react';
import {
  isRemitReportingSubscriptionActive,
  remitReportingSubscriptionInfoLoading,
  ReportingSubscriptionTradeType,
  useRemitReportingSubscriptionInfo,
} from 'src/pages/reporting/secondary-tradings/overview/use-remit-reporting-subscription-info';
import { Forbidden } from 'src/utils/errors';

export const SubscriptionActiveGuard: FC<{
  children: ReactNode;
  tradeType: ReportingSubscriptionTradeType;
}> = ({ children, tradeType }) => {
  const infoRequest = useRemitReportingSubscriptionInfo(tradeType);

  if (remitReportingSubscriptionInfoLoading(infoRequest)) return null;

  if (!isRemitReportingSubscriptionActive(infoRequest)) throw new Forbidden();

  return <>{children}</>;
};
